// @ts-nocheck
/* eslint-disable spire/export-styles */
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import ManageShareListModal from "@insite/content-library/Components/ManageShareListModal";
import ProductDeliveryScheduleModal from "@insite/content-library/Components/ProductDeliveryScheduleModal";
import ProductSelectorVariantModal from "@insite/content-library/Components/ProductSelectorVariantModal";
import ShareListDetailModal from "@insite/content-library/Components/ShareListDetailModal";
import ShareListModal from "@insite/content-library/Components/ShareListModal";
import * as React from "react";

// Store Custom Code
import ProductCompareFlyOut from "@insite/content-library/Components/ProductCompareFlyOut";
import constants from "@toolkit/constants";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";

interface OwnProps {
    skipInventoryValidation?: boolean;
    skipProductPrice?: boolean;
}

type Props = OwnProps;

const Modals = ({ skipInventoryValidation, skipProductPrice }: Props) => {
    /* Store Custom Code - Start */
    const currentPage = useCurrentPage();
    const showFlyout = constants.pageType.productCompare !== currentPage.type;
    /* Store Custom Code - End */
    return (
        <>
            <AddToListModal />
            <ShareListModal />
            <ManageShareListModal />
            <ShareListDetailModal />
            {/* Store Custom Code */}
            {showFlyout && <ProductCompareFlyOut />}
            <ProductSelectorVariantModal
                skipInventoryValidation={skipInventoryValidation}
                skipProductPrice={skipProductPrice}
            />
            <ProductDeliveryScheduleModal />
        </>
    );
};

export default Modals;
